import React from 'react';

const RedemptionPill = ({ type, drawingDate, endDate, status = 'active', isCompleted = false }) => {
  const formatDate = (dateString) => {
    if (!dateString) return 'Date TBD';

    try {
      const date = new Date(dateString);
      const options = {
        month: 'short',
        day: 'numeric',
        hour: 'numeric',
        minute: '2-digit',
        hour12: true
      };
      return date.toLocaleDateString('en-US', options);
    } catch (error) {
      return 'Date TBD';
    }
  };

  const getPillStyle = () => {
    const baseStyle = {
      padding: '8px 16px',
      borderRadius: '8px',
      marginBottom: '8px',
      width: '100%',
      textAlign: 'center',
      borderWidth: '1px',
      borderStyle: 'solid',
      cursor: 'default'
    };

    switch (status) {
      case 'completed':
        return {
          ...baseStyle,
          backgroundColor: '#E8F5E8',
          borderColor: '#4CAF50',
          color: '#4CAF50'
        };
      case 'cancelled':
        return {
          ...baseStyle,
          backgroundColor: '#FFEBEE',
          borderColor: '#F44336',
          color: '#F44336'
        };
      case 'draft':
        return {
          ...baseStyle,
          backgroundColor: '#FFF8E1',
          borderColor: '#FF9800',
          color: '#FF9800'
        };
      default: // 'active'
        return {
          ...baseStyle,
          backgroundColor: '#E3F2FD',
          borderColor: '#2196F3',
          color: '#2196F3'
        };
    }
  };

  const getDisplayText = () => {
    if (type === 'raffle') {
      const prefix = isCompleted ? 'Raffle - Drawn:' : 'Raffle - Drawing:';
      return `${prefix} ${formatDate(drawingDate)}`;
    } else if (type === 'auction') {
      const prefix = isCompleted ? 'Auction - Ended:' : 'Auction - Ends:';
      return `${prefix} ${formatDate(endDate)}`;
    }
    return '';
  };

  return (
    <div
      style={getPillStyle()}
    >
      <span style={{
        fontSize: '14px',
        fontWeight: '500',
        fontFamily: 'system-ui, -apple-system, sans-serif'
      }}>
        {getDisplayText()}
      </span>
    </div>
  );
};

export default RedemptionPill;